export default `# See instructions here:
https://www.nuget.org/packages/System.IdentityModel.Tokens.Jwt/`;
